import React from 'react';
import { Chip } from '@mui/material';
import { helper } from '../../../utils/helper';

/**
 * Badge coloré pour un type de déchet (VER, OM, REC, PAP, BIO, ...).
 * Utilise `helper.getColorForDechetType` — couleurs partagées dans toute l'app.
 *
 * Props :
 *  - type : code du type de déchet (string)
 *  - label : libellé affiché (par défaut = type)
 *  - size : taille du Chip (par défaut "small")
 *  - sx : surcharges éventuelles
 */
function DechetTypeChip({ type, label, size = 'small', sx, ...rest }) {
    if (!type) return null;
    return (
        <Chip
            size={size}
            label={label ?? type}
            sx={{ ...helper.getColorForDechetType(type), fontWeight: 500, ...sx }}
            {...rest}
        />
    );
}

export default DechetTypeChip;
